import React from 'react';
import { useFormik } from 'formik';
import {
  Input,
  Button,
  FormControl,
  FormLabel,
  VStack,
  Text,
} from '@chakra-ui/react';
import * as yup from 'yup';
import { addManyChanges } from '../../store/api_funcs';
import { useStores } from '../../store/store_context';
import { useState } from 'react';
import PanelsSearch from '../panels_autocomplete';
import { useEffect } from 'react';

// Валидационная схема с использованием Yup
const validationSchema = yup.object({
  adress: yup.string(),
  model_url: yup.string(),
});

const ManyEditForm = ({
  group_id,
  groups,
  updatePanelsTable,
  updateGroups,
  panels,
}) => {
  const [panel_id, setPanelId] = useState('1111');
  const [theme, setTheme] = useState('');
  const { pageStore } = useStores();
  const getUserTheme = async () => {
    const response = await fetch(
      `https://admin.i-panel.pro:8787/api/panels/theme_id/${panel_id}`,
      {
        method: 'GET',
        headers: {
          accept: 'application/json',
        },
      }
    );
    const result = await response.json();
    setTheme(result ? result[0] : '');
    console.log(result);
  };
  useEffect(() => {
    getUserTheme();
  }, [panel_id]);
  const formik = useFormik({
    initialValues: {
      theme: theme,
      adress: '',
      model_url: '',
    },
    enableReinitialize: true,

    validationSchema,
    onSubmit: async values => {
      // Обработка отправки формы
      await addManyChanges(values, group_id, pageStore.token);
      await updatePanelsTable();
      await updateGroups();
      console.log('Отправленные значения:', values);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormControl
        id="address"
        isInvalid={formik.touched.adress && formik.errors.adress}
      >
        <FormLabel marginTop={'8px'}>Адрес</FormLabel>
        <Input
          type="text"
          id="adress"
          name="adress"
          onChange={formik.handleChange}
          value={formik.values.adress}
          marginTop={'8px'}
        />
      </FormControl>

      <FormControl
        id="model_url"
        isInvalid={formik.touched.model_url && formik.errors.model_url}
      >
        <FormLabel marginTop={'8px'}>Модель нейросети</FormLabel>
        <Input
          type="text"
          id="model_url"
          name="model_url"
          onChange={formik.handleChange}
          value={formik.values.model_url}
          marginTop={'8px'}
        />
      </FormControl>
      <VStack align={'flex-start'} paddingTop={'18px'}>
        <Text>
          Выберите панель, чью тему нужно применить ко всем панелям в группе
        </Text>
        <Text fontSize={12} color={'gray'}>
          Начните вводить номер панели для выбора. Учтите, что тема применяемая
          к группе должна быть рассчитана на разрешения этих панелей
        </Text>
        {pageStore.edit_themes ? (
          <PanelsSearch
            setResult={setPanelId}
            items={panels.map(elem => {
              return {
                id: elem.panel_id,
                name: elem.adress,
                number: elem.fabric_number,
              };
            })}
            fabric={true}
          />
        ) : null}

        <Button
          type="submit"
          backgroundColor={'#7B79FF'}
          _hover={{ backgroundColor: '#4945FF' }}
          color="white"
          marginTop={'8px'}
        >
          Отправить
        </Button>
      </VStack>
    </form>
  );
};
export default ManyEditForm;
